<template>
  <ui-dialog
    :title="L10n('confirm')"
    :isVisible="isVisible"
    @close="onCancel"
  >
    <span>{{ L10n('part-status') }} {{ statusName }} {{ L10n('are-you-sure') }}</span>
    <template v-slot:footer>
      <div class="activity-po-wo-wrap__footer">
        <button class="btn btn-border grey btn-size-s btn-mobile-full" @click="onCancel">
          {{ L10n('close') }}
        </button>
        <button class="ml-sm-3 btn btn-border blue btn-size-s btn-mobile-full" @click="onConfirm">
          {{ L10n('confirm') }}
        </button>
      </div>
    </template>
  </ui-dialog>
</template>

<script>

export default {
  name: 'DialogConfirmStockStatus',
  components: {
    'ui-dialog': () => import(/* webpackChunkName: 'Shared' */ '@/components/Dialogs/Dialog')
  },
  props: {
    isVisible: { type: Boolean },
    statusID: { required: false }
  },
  computed: {
    dataSourceStatus () {
      return this.API('Statuses/GetAllDynamic?select=id,title')
    },
    statusName () {
      const data = this.dataSourceStatus.map[this.statusID]
      return (data && data.title) || '---'
    }
  },
  methods: {
    onCancel () {
      this.$emit('onCancel', this.statusID)
    },
    onConfirm () {
      this.$emit('onConfirm', this.statusID)
    }
  }
}
</script>
